(() => {
  'use strict';
  if (window.__PW_CART_93__) return;
  window.__PW_CART_93__ = true;
  const freeShippingThreshold = 10000;
  const WIPES_OFFER_VARIANTS = new Set(['57265074766202','57265075356026','57265080533370','57265080992122']);
  const shared = window.__PW_CART_DATA__ ||= { value: null, at: 0, pending: null, generation: 0 };
  let currentCart = null;
  let refreshTimer = null;
  const money = (cents) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(Number(cents || 0) / 100);

  const BMSM_RULES = (() => {
    try {
      const payload = JSON.parse(document.getElementById('pw-bmsm-storefront-data')?.textContent || '{}');
      return payload?.version === 1 && payload.rules && typeof payload.rules === 'object' ? payload.rules : {};
    } catch (_) { return {}; }
  })();
  function bmsmProjection(snapshot) {
    const items = Array.isArray(snapshot?.items) ? snapshot.items : [];
    const result = { savings: 0, rows: new Map() };
    const applications = snapshot?.cart_level_discount_applications || [];
    const hasOtherDiscount = (snapshot?.discount_codes || []).length > 0 ||
      applications.some(a => Number(a?.total_allocated_amount || a?.amount || 0) > 0) ||
      items.some(item => (item.line_level_discount_allocations || []).some(a => {
        const title = String(a?.discount_application?.title || a?.title || '');
        return !/buy\s+more,?\s+save\s+more/i.test(title);
      }));
    if (hasOtherDiscount) return result;
    const totalByProduct = new Map();
    items.forEach(item => {
      if (item?.properties?._pw_winback_bogo_gift === 'true') return;
      const id = String(item.product_id || '').replace(/\D/g, '');
      if (BMSM_RULES[id]) totalByProduct.set(id, (totalByProduct.get(id) || 0) + Math.max(0, Number(item.quantity || 0)));
    });
    items.forEach(item => {
      if (item?.properties?._pw_winback_bogo_gift === 'true') return;
      const id = String(item.product_id || '').replace(/\D/g, '');
      const qty = totalByProduct.get(id) || 0;
      const tiers = BMSM_RULES[id]?.tiers || [];
      const matching = Array.isArray(tiers) ? tiers.find(tier =>
        qty >= Number(tier.minQty || 1) && (tier.maxQty == null || qty <= Number(tier.maxQty))) : null;
      const rate = Math.max(0, Math.min(100, Number(matching?.percentage || 0)));
      if (!rate) return;
      const original = Math.max(0, Number(item.original_line_price ?? (Number(item.price || 0) * Number(item.quantity || 0))));
      const actual = Math.max(0, Number(item.final_line_price ?? original));
      // Never substitute an estimate for an actual Shopify line discount.
      if (actual < original || (item.line_level_discount_allocations || []).length) return;
      const estimatedFinal = Math.round(original * (100 - rate) / 100);
      const amount = Math.max(0, original - estimatedFinal);
      if (amount === 0) return;
      result.rows.set(String(item.key), { original, estimatedFinal, amount, rate });
      result.savings += amount;
    });
    return result;
  }
  window.PWBmsmCartProjection = bmsmProjection;
  async function getCart(force = false) {
    if (!force && shared.pending) {
      currentCart = await shared.pending;
      return currentCart;
    }
    // Forced reads must ALWAYS bypass the 300ms shared cache.
    // Reusing a snapshot after quantity/remove mutations redraws old rows.
    if (!force && shared.value) return (currentCart = shared.value);
    if (!force && currentCart) return currentCart;
    const generation = ++shared.generation;
    const request = fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
      credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store'
    }).then((response) => {
      if (!response.ok) throw new Error('Cart could not be loaded');
      return response.json();
    }).then((cart) => {
      if (generation === shared.generation) {
        shared.value = cart;
        shared.at = Date.now();
        currentCart = cart;
      }
      return currentCart || shared.value || cart;
    });
    shared.pending = request;
    try { return await request; }
    finally { if (shared.pending === request) shared.pending = null; }
  }
  function wiseCreditMarkup(cart) {
    const rate = Number(document.body?.dataset?.pwWiseEarnPercent || 1);
    const authenticated = document.body?.dataset?.pwWiseAuthenticated === 'true';
    const eligible = Math.max(0, Number(cart.total_price || 0));
    const credit = Math.max(0, Math.round(eligible * rate / 100));
    if (!credit || Number(cart.item_count || 0) <= 0) return '';
    const template = authenticated
      ? document.body?.dataset?.pwWiseCartMemberTemplate
      : document.body?.dataset?.pwWiseCartGuestTemplate;
    const message = String(template || '').replace('[amount]', '<strong>' + money(credit) + '</strong>');
    return `<div class="pw-wise-cart-earn" data-pw-wise-cart-earn><span class="pw-wise-cart-earn__icon" aria-hidden="true">+</span><span class="pw-wise-cart-earn__text">${message}</span></div>`;
  }
  function updateWiseCredit(cart) {
    const markup = wiseCreditMarkup(cart);
    document.querySelectorAll('header-cart-drawer .cart__footer,#CartPageForm .cart__page-col.medium-up--overlay').forEach((host) => {
      const existing = host.querySelector('[data-pw-wise-cart-earn]');
      if (!markup) { existing?.remove(); return; }
      if (existing && existing.__pwMarkup === markup) return;
      if (existing) existing.outerHTML = markup;
      else {
        const subtotal = host.querySelector('.cart__item--subtotal');
        if (subtotal) subtotal.insertAdjacentHTML('beforebegin', markup);
        else host.insertAdjacentHTML('afterbegin', markup);
      }
      const current = host.querySelector('[data-pw-wise-cart-earn]');
      if (current) current.__pwMarkup = markup;
    });
  }
  function shippingMarkup(cart) {
    const eligible = Number(cart.items_subtotal_price ?? cart.total_price ?? 0);
    const remaining = Math.max(0, freeShippingThreshold - eligible);
    const percentage = Math.min(100, Math.max(0, eligible / freeShippingThreshold * 100));
    const message = remaining === 0 ? 'Free shipping unlocked' : `Spend <strong>${money(remaining)}</strong> more for free shipping`;
    return `<div class="pw-shipping-progress ${remaining === 0 ? 'is-complete' : ''}" data-pw-shipping><div class="pw-shipping-progress__text">${message}</div><div class="pw-shipping-progress__track" aria-hidden="true"><div class="pw-shipping-progress__bar" style="width:${percentage}%"></div></div><small class="pw-shipping-progress__note">Final shipping is confirmed at checkout.</small></div>`;
  }
  function syncDrawerViewport() {
    document.querySelectorAll('header-drawer.site-header__cart').forEach((drawer) => {
      drawer.style.setProperty('--pw-cart-top', `${Math.max(0, Math.round(drawer.getBoundingClientRect().top))}px`);
    });
  }
  function bundleRate(item) {
    const properties = item.properties || {};
    const source = properties._bundle_source || properties.bundle_source;
    const rate = properties._bundle_discount_rate || properties.bundle_discount_rate;
    const discounted = Number(item.original_line_price || 0) > Number(item.final_line_price || 0) || (item.line_level_discount_allocations || []).length > 0;
    return source === 'bundle_builder' && rate && discounted ? String(rate) : '';
  }
  // Never use cart properties as proof of a discount. Shopify's final prices and
  // discount allocations are authoritative; the preview marker only scopes display.
  function isPreviewBundle(item) {
    return item?.properties?._pw_preview_bundle === 'true';
  }
  function bundleDiscountAllocation(item) {
    if (!isPreviewBundle(item)) return null;
    return (item.line_level_discount_allocations || []).find(alloc => {
      const title = String(alloc.discount_application?.title || alloc.title || '');
      return /pw\s+(?:preview\s+)?bundle|pw\s+bundle\s+preview/i.test(title);
    }) || null;
  }
  function actualBundleSavings(cart) {
    return (cart.items || []).reduce((total, item) => {
      if (!bundleDiscountAllocation(item)) return total;
      return total + Math.max(0, Number(item.original_line_price || 0) - Number(item.final_line_price || 0));
    }, 0);
  }
  function updateBundleDiscountSummary(cart) {
    const savings = actualBundleSavings(cart);
    document.querySelectorAll('header-cart-drawer [data-discounts]').forEach(slot => {
      let row = slot.querySelector('[data-pw-actual-bundle-discount]');
      if (!savings) { row?.remove(); return; }
      if (!row) {
        row = document.createElement('div');
        row.className = 'pw-actual-bundle-discount';
        row.setAttribute('data-pw-actual-bundle-discount', '');
        row.style.cssText = 'display:flex;justify-content:space-between;gap:12px;align-items:center;padding:8px 0;color:#17632b;font-size:13px;font-weight:750;';
        slot.appendChild(row);
      }
      const markup = '<span>PW Bundle discount applied</span><strong>-' + money(savings) + '</strong>';
      if (row.__pwMarkup !== markup) { row.innerHTML = markup; row.__pwMarkup = markup; }
    });
  }
  function enhanceDrawerLines(cart) {
    const preview = bmsmProjection(cart);
    (cart.items || []).forEach((item) => {
      [...document.querySelectorAll('header-cart-drawer .cart__item[data-key]')].filter((line) => line.dataset.key === item.key).forEach((line) => {
        let total = line.querySelector('.pw-cart-line-total');
        if (!total) { total = document.createElement('div'); total.className = 'pw-cart-line-total'; line.append(total); }
        const isDiscountedBundle = Boolean(bundleDiscountAllocation(item));
        const original = Number(item.original_line_price || 0);
        const final = Number(item.final_line_price || 0);
        const isDiscountedVolume = original > final && (item.line_level_discount_allocations || []).some(alloc => /buy\s+more,?\s+save\s+more/i.test(String(alloc.discount_application?.title || alloc.title || '')));
        const recommendedWipeVariant = WIPES_OFFER_VARIANTS.has(String(item.variant_id || ''));
        const isDiscountedWipes = recommendedWipeVariant
          && item.properties?._pw_cart_recommendation === 'true'
          && (item.line_level_discount_allocations || []).length > 0
          && Number(item.quantity || 0) > 0
          && Math.abs(original - final - (300 * Number(item.quantity))) < 1;
        const estimated = preview.rows.get(String(item.key));
        const markup = (isDiscountedBundle || isDiscountedVolume || isDiscountedWipes) && original > final
          ? '<span>Line total</span><span style="display:flex;align-items:center;gap:7px;flex-wrap:wrap"><s style="color:#748077">' + money(original) + '</s><strong>' + money(final) + '</strong></span>'
          : estimated
            ? '<span>Est. line total at checkout</span><span style="display:flex;align-items:center;gap:7px;flex-wrap:wrap"><s style="color:#748077">' + money(original) + '</s><strong>' + money(estimated.estimatedFinal) + '</strong></span>'
            : '<span>Line total</span><strong>' + money(final) + '</strong>';
        if (total.__pwMarkup !== markup) { total.innerHTML = markup; total.__pwMarkup = markup; }
        const rate = bundleRate(item), title = line.querySelector('.cart__item-title');
        let badge = title?.querySelector('.pw-bundle-badge');
        if ((rate || isDiscountedBundle || isDiscountedVolume || isDiscountedWipes || estimated) && title) {
          if (!badge) { badge = document.createElement('div'); badge.className = 'pw-bundle-badge'; title.append(badge); }
          const text = isDiscountedWipes
            ? 'Wet Wipes cart offer · £3 off each'
            : isDiscountedVolume
            ? 'Buy More Save More · ' + (original ? (() => { const rate = (original - final) * 100 / original; const whole = Math.round(rate); return Math.abs(rate - whole) < 0.08 ? whole : Math.round(rate * 100) / 100; })() : 0) + '% · You save ' + money(original - final)
            : estimated
              ? 'Buy More Save More \u00b7 est. ' + estimated.rate + '% · You save ' + money(estimated.amount) + ' at checkout'
            : isDiscountedBundle
              ? 'PW Bundle discount applied'
              : 'Bundle discount applied \u00b7 ' + rate + '%';
          if (badge.textContent !== text) badge.textContent = text;
        } else badge?.remove();
      });
    });
  }
  function ensureDrawerActions() {
    document.querySelectorAll('header-cart-drawer .cart__footer').forEach((footer) => {
      const checkout = footer.querySelector('.cart__checkout-wrapper'); if (!checkout) return;
      let viewCart = footer.querySelector('.pw-cart-drawer-view');
      if (!viewCart) {
        viewCart = document.createElement('a'); viewCart.className = 'pw-cart-drawer-view';
        viewCart.href = `${window.Shopify?.routes?.root || '/'}cart`; viewCart.textContent = 'View cart';
      }
      if (viewCart.nextElementSibling !== checkout) checkout.before(viewCart);
      for (const [name,value] of Object.entries({margin:'0 0 10px','min-height':'52px',background:'#124c32','border-color':'#124c32',color:'#ffffff','font-weight':'850'})) viewCart.style.setProperty(name,value,'important');
      checkout.querySelectorAll('.element-button,.cart__checkout').forEach((button) => {
        button.style.setProperty('background','#d4ff7c','important'); button.style.setProperty('border','1px solid rgba(15,39,27,.45)','important'); button.style.setProperty('color','#0f271b','important'); button.style.setProperty('box-shadow','none','important');
      });
      footer.querySelector('.pw-cart-drawer-actions')?.remove();
    });
  }
  function updateShipping(cart) {
    const markup = shippingMarkup(cart);
    document.querySelectorAll('header-cart-drawer .cart__footer,#CartPageForm .cart__page-col.medium-up--overlay').forEach((host) => {
      const target = host.matches('#CartPageForm .cart__page-col.medium-up--overlay')
        ? (host.querySelector('[data-pw-page-shipping-slot]') || host)
        : host;
      const existing = target.querySelector('[data-pw-shipping]');
      if (existing && existing.__pwMarkup === markup) return;
      if (existing) existing.outerHTML = markup; else target.insertAdjacentHTML('afterbegin', markup);
      const current = target.querySelector('[data-pw-shipping]');
      if (current) current.__pwMarkup = markup;
    });
  }
  function syncSelection() {
    const checks = [...document.querySelectorAll('#CartPageForm .pw-cart-line-check')], selected = checks.filter((check) => check.checked);
    const all = document.querySelector('[data-pw-select-all]'), remove = document.querySelector('[data-pw-remove-selected]');
    if (all) { all.checked = checks.length > 0 && selected.length === checks.length; all.indeterminate = selected.length > 0 && selected.length < checks.length; }
    if (remove) remove.disabled = selected.length === 0;
  }
  function enhanceCartPage(cart) {
    if (!document.getElementById('CartPageForm')) return;
    (cart.items || []).forEach((item) => {
      document.querySelectorAll(`#CartPageForm .cart__item[data-key="${CSS.escape(item.key)}"]`).forEach((line) => {
        if (line.querySelector('.pw-cart-line-check')) return;
        const check = document.createElement('input'); check.type='checkbox'; check.className='pw-cart-line-check'; check.dataset.key=item.key;
        check.setAttribute('aria-label',`Select ${item.product_title || 'cart item'}`); check.addEventListener('change',syncSelection); line.prepend(check);
      });
    });
    const products = document.querySelector('#CartPageForm [data-products]');
    if (products) {
      let bar=products.previousElementSibling;
      if(!bar?.classList.contains('pw-cart-selection')) {
        bar=document.createElement('div');bar.className='pw-cart-selection';
        bar.innerHTML='<label class="pw-cart-selection__check"><input type="checkbox" data-pw-select-all> Select all products</label><button type="button" class="pw-cart-selection__remove" data-pw-remove-selected disabled>Remove selected</button>';
        products.before(bar);
        const selectAll = bar.querySelector('[data-pw-select-all]');
        selectAll?.addEventListener('change',(event)=>{document.querySelectorAll('#CartPageForm .pw-cart-line-check').forEach(check=>{check.checked=event.target.checked;});syncSelection();});
      }
    }
    syncSelection();
  }
  function renderCart(cart) {
    if(!cart)return;
    document.querySelectorAll('[data-pw-wise-cart-earn]').forEach((node)=>node.remove());
    ensureDrawerActions();
    updateShipping(cart);
    enhanceDrawerLines(cart);
    updateBundleDiscountSummary(cart);
    enhanceCartPage(cart);
    syncDrawerViewport();
    document.dispatchEvent(new CustomEvent('pw:cart:rendered',{detail:{cart}}));
  }
  async function mutate(url,body,reload=false) {
    document.documentElement.classList.add('pw-cart-busy');
    try {
      const response=await fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
      const data=await response.json();if(!response.ok)throw data;
      currentCart=null;shared.value=null;shared.generation++;
      if(reload){location.reload();return;}
      document.dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true,detail:{product:data}}));scheduleRefresh(true,120);
    }catch(error){console.error('Packaging Wise cart update failed',error);}finally{document.documentElement.classList.remove('pw-cart-busy');}
  }
  function removeSelected(){
    const updates={};
    document.querySelectorAll('#CartPageForm .pw-cart-line-check:checked')
      .forEach(check=>{updates[check.dataset.key]=0;});
    if(!Object.keys(updates).length)return;
    const basket=currentCart || shared.value;
    const selected=String(basket?.attributes?._pw_winback_selected_variant||'').match(/ProductVariant\/(\d+)$/)?.[1];
    const items=basket?.items||[];
    const groupIsSelected=selected&&items.some(item=>String(item.variant_id)===selected&&updates[item.key]===0);
    let body={updates,sections:['cart-ajax'],sections_url:location.pathname};
    if(groupIsSelected){
      // Selecting one visible BOGO row removes the entire grouped SKU,
      // including any hidden free row. Preserve unrelated voucher codes.
      items.filter(item=>String(item.variant_id)===selected).forEach(item=>{updates[item.key]=0;});
      const code=String(document.getElementById('pw-winback-bogo-root')?.dataset.code||'').toUpperCase();
      const discounts=(basket?.discount_codes||[])
        .map(item=>String(item.code||''))
        .filter(c=>c&&c.toUpperCase()!==code);
      body={
        ...body,
        attributes:{...(basket?.attributes||{}),_pw_winback_selected_variant:''},
        discount:discounts.join(','),
      };
    }
    return mutate(`${window.Shopify?.routes?.root || '/'}cart/update.js`,body,true);
  }
  async function refresh(force=false){try{renderCart(await getCart(force));}catch(error){console.warn('Packaging Wise cart enhancements failed',error);}}
  function scheduleRefresh(force=false,delay=80){clearTimeout(refreshTimer);refreshTimer=setTimeout(()=>refresh(force),delay);}
  document.addEventListener('click',(event)=>{
    if(event.target.closest('[data-pw-cart-close]')){
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:close'));
      return;
    }
    if(event.target.closest('[data-pw-remove-selected]')){event.preventDefault();removeSelected();}
  });
  document.addEventListener('pw:cart:state',(e)=>{if(!e.detail?.cart)return;currentCart=e.detail.cart;shared.value=currentCart;shared.at=Date.now();clearTimeout(refreshTimer);renderCart(currentCart);});
  ['ajaxProduct:added','product-form:cart:update','cart:updated','cart:refresh'].forEach(name=>document.addEventListener(name,(event)=>{
    const next=event.detail?.cart || (Array.isArray(event.detail?.product?.items)?event.detail.product:null);
    if(next){currentCart=next;shared.value=next;shared.at=Date.now();shared.generation++;scheduleRefresh(false,50);}
    else{currentCart=null;scheduleRefresh(true,100);}
  }));
  window.addEventListener('pageshow',(event)=>{if(event.persisted){currentCart=null;scheduleRefresh(true,0);}});
  window.addEventListener('resize',()=>{if(document.querySelector('header-drawer.site-header__cart.is-active'))syncDrawerViewport();},{passive:true});
  document.addEventListener('cart:open',()=>{
    if(shared.value) renderCart(shared.value);
    else scheduleRefresh(true,0);
  });
  function warmCartState(){
    if(shared.value || shared.pending || !document.querySelector('header-cart-drawer')) return;
    const run=()=>getCart(false).catch(()=>null);
    if('requestIdleCallback' in window) requestIdleCallback(run,{timeout:700});
    else setTimeout(run,120);
  }
  function init(){
    warmCartState();
    if(!document.querySelector('#CartPageForm')) return;
    if(shared.value) renderCart(shared.value);
    else refresh(false);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
